"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pim_api = void 0;
var _lsfastapiClient = require("@lsoft/lsfastapi-client");
var openapi = {
  openapi: "3.1.0",
  info: {
    title: "pim-api",
    version: "3.2.33"
  },
  paths: {
    "/product/{sku}/checksum": {
      get: {
        tags: ["product"],
        summary: "Router Product Checksum Get",
        operationId: "product__sku__checksum_get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ChecksumResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/render_channel_data": {
      get: {
        tags: ["product"],
        summary: "Router Product Render Channel Data Get",
        operationId: "product__sku__render_channel_data_get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/RenderChannelDataModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}": {
      get: {
        tags: ["product"],
        summary: "Router Product Get",
        operationId: "product__sku__get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ProductModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["product"],
        summary: "Router Product Patch",
        operationId: "product__sku__patch",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }, {
          name: "org_id",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Org Id"
          }
        }, {
          name: "force_create",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": true,
            title: "Force Create"
          }
        }, {
          name: "return_pim_product",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Return Pim Product"
          }
        }, {
          name: "render_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "erp",
            title: "Render Class"
          }
        }, {
          name: "render_async",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Render Async"
          }
        }, {
          name: "render_all",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": true,
            title: "Render All"
          }
        }, {
          name: "initiate_render",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": true,
            title: "Initiate Render"
          }
        }, {
          name: "priority",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Priority"
          }
        }],
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/Body_router_product_patch_product__sku__patch"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/products": {
      put: {
        tags: ["product"],
        summary: "Router Products Put",
        operationId: "products_put",
        parameters: [{
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "ids_merge_mode",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "APPEND",
            title: "Ids Merge Mode"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "options",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Options"
          }
        }, {
          name: "filter_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "BASE",
            title: "Filter Class"
          }
        }, {
          name: "reset",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Reset"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                "default": {},
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product": {
      post: {
        tags: ["product"],
        summary: "Router Product Post",
        operationId: "product_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ProductModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ProductModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/validation_info": {
      get: {
        tags: ["product"],
        summary: "Router Product Validation Load",
        operationId: "product__sku__validation_info_get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  anyOf: [{
                    $ref: "#/components/schemas/ValidationInfoModel"
                  }, {
                    type: "null"
                  }],
                  title: "Response Router Product Validation Load Product  Sku  Validation Info Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/group_tags": {
      get: {
        tags: ["product"],
        summary: "Router Product Group Tags Get",
        operationId: "product__sku__group_tags_get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/product/{sku}/shared_data": {
      get: {
        tags: ["product"],
        summary: "Router Product Shared Data Get",
        operationId: "product__sku__shared_data_get",
        parameters: [{
          name: "sku",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Sku"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  title: "Response Router Product Shared Data Get Product  Sku  Shared Data Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/group_tag": {
      get: {
        tags: ["group-tags"],
        summary: "Group Tag Get",
        operationId: "group_tag_get",
        parameters: [{
          name: "uid",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/GroupTagModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      post: {
        tags: ["group-tags"],
        summary: "Group Tag Post",
        operationId: "group_tag_post",
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/GroupTagModel"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/GroupTagModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["group-tags"],
        summary: "Group Tag Patch",
        operationId: "group_tag_patch",
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/GroupTagModel"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/GroupTagModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["group-tags"],
        summary: "Group Tag Delete",
        operationId: "group_tag_delete",
        parameters: [{
          name: "uid",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/group_tags": {
      get: {
        tags: ["group-tags"],
        summary: "Group Tags Get",
        operationId: "group_tags_get",
        parameters: [{
          name: "uids",
          "in": "query",
          required: false,
          schema: {
            type: "array",
            items: {
              type: "string"
            },
            title: "Uids"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  additionalProperties: {
                    $ref: "#/components/schemas/GroupTagModel"
                  },
                  title: "Response Group Tags Get Group Tags Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["group-tags"],
        summary: "Group Tags Put",
        operationId: "group_tags_put",
        parameters: [{
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "ids_merge_mode",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "APPEND",
            title: "Ids Merge Mode"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "options",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Options"
          }
        }, {
          name: "filter_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "BASE",
            title: "Filter Class"
          }
        }, {
          name: "reset",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Reset"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                "default": {},
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PaginationViewResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/group_tags_search": {
      get: {
        tags: ["group-tags"],
        summary: "Group Tags Search",
        operationId: "group_tags_search_get",
        parameters: [{
          name: "search_terms",
          "in": "query",
          required: false,
          schema: {
            type: "string",
            title: "Search Terms"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  additionalProperties: {
                    $ref: "#/components/schemas/GroupTagModel"
                  },
                  title: "Response Group Tags Search Group Tags Search Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturer/{mid}": {
      get: {
        tags: ["manufacturer"],
        summary: "Manufacturer Get",
        operationId: "manufacturer__mid__get",
        parameters: [{
          name: "mid",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Mid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ManufacturerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      "delete": {
        tags: ["manufacturer"],
        summary: "Manufacturer Delete",
        operationId: "manufacturer__mid__delete",
        parameters: [{
          name: "mid",
          "in": "path",
          required: true,
          schema: {
            type: "integer",
            title: "Mid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturers": {
      get: {
        tags: ["manufacturer"],
        summary: "Manufacturers Get",
        operationId: "manufacturers_get",
        parameters: [{
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "ids_merge_mode",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "APPEND",
            title: "Ids Merge Mode"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "options",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Options"
          }
        }, {
          name: "filter_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "BASE",
            title: "Filter Class"
          }
        }, {
          name: "reset",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Reset"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                "default": {},
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      put: {
        tags: ["manufacturer"],
        summary: "Manufacturers Put",
        operationId: "manufacturers_put",
        parameters: [{
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "ids_merge_mode",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "APPEND",
            title: "Ids Merge Mode"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "options",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Options"
          }
        }, {
          name: "filter_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "BASE",
            title: "Filter Class"
          }
        }, {
          name: "reset",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Reset"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                anyOf: [{
                  type: "object"
                }, {
                  type: "null"
                }],
                "default": {},
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/PaginationViewResponseModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturer": {
      post: {
        tags: ["manufacturer"],
        summary: "Manufacturer Post",
        operationId: "manufacturer_post",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ManufacturerBaseModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ManufacturerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      patch: {
        tags: ["manufacturer"],
        summary: "Manufacturer Patch",
        operationId: "manufacturer_patch",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ManufacturerModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ManufacturerModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/manufacturer_search": {
      get: {
        tags: ["manufacturer"],
        summary: "Manufacturer Search",
        operationId: "manufacturer_search_get",
        parameters: [{
          name: "search_terms",
          "in": "query",
          required: false,
          schema: {
            type: "string",
            title: "Search Terms"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  type: "object",
                  additionalProperties: {
                    $ref: "#/components/schemas/ManufacturerModel"
                  },
                  title: "Response Manufacturer Search Manufacturer Search Get"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/import_product/manufacturers": {
      get: {
        tags: ["import_products"],
        summary: "Router Available Import Classes",
        operationId: "import_product_manufacturers_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  items: {},
                  type: "array",
                  title: "Response Router Available Import Classes Import Product Manufacturers Get"
                }
              }
            }
          }
        }
      }
    },
    "/import_product": {
      post: {
        tags: ["import_products"],
        summary: "Router Import Product",
        operationId: "import_product_post",
        parameters: [{
          name: "import_class",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Import Class"
          }
        }, {
          name: "msku",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Msku"
          }
        }, {
          name: "date",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Date"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/import_product/task": {
      put: {
        tags: ["import_products"],
        summary: "Router Check Task Status By Task",
        operationId: "import_product_task_put",
        parameters: [{
          name: "task_name",
          "in": "query",
          required: true,
          schema: {
            type: "string",
            title: "Task Name"
          }
        }, {
          name: "skip",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip"
          }
        }, {
          name: "limit",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit"
          }
        }, {
          name: "ids_merge_mode",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "APPEND",
            title: "Ids Merge Mode"
          }
        }, {
          name: "sort",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Sort"
          }
        }, {
          name: "options",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Options"
          }
        }, {
          name: "filter_class",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            "default": "BASE",
            title: "Filter Class"
          }
        }, {
          name: "reset",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            "default": false,
            title: "Reset"
          }
        }, {
          name: "view",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/import_product/task/{uid}": {
      "delete": {
        tags: ["import_products"],
        summary: "Router Delete Task",
        operationId: "import_product_task__uid__delete",
        parameters: [{
          name: "uid",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      },
      post: {
        tags: ["import_products"],
        summary: "Router Retry Task",
        operationId: "import_product_task__uid__post",
        parameters: [{
          name: "uid",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Uid"
          }
        }, {
          name: "date",
          "in": "query",
          required: false,
          schema: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Date"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/validation_info/{val_class}/{val_uid}": {
      get: {
        tags: ["validation"],
        summary: "Router Validation Info Get",
        operationId: "validation_info__val_class___val_uid__get",
        parameters: [{
          name: "val_class",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Val Class"
          }
        }, {
          name: "val_uid",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Val Uid"
          }
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/validation_infos/{val_class}": {
      put: {
        tags: ["validation"],
        summary: "Router Validation Infos Get",
        operationId: "validation_infos__val_class__put",
        parameters: [{
          name: "val_class",
          "in": "path",
          required: true,
          schema: {
            type: "string",
            title: "Val Class"
          }
        }],
        requestBody: {
          required: true,
          content: {
            "application/json": {
              schema: {
                title: "Body"
              }
            }
          }
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      Body_router_product_patch_product__sku__patch: {
        properties: {
          product: {
            $ref: "#/components/schemas/ProductModel"
          },
          merge_spec: {
            type: "object",
            title: "Merge Spec"
          },
          hook_processing: {
            type: "object",
            title: "Hook Processing"
          }
        },
        type: "object",
        required: ["product"],
        title: "Body_router_product_patch_product__sku__patch"
      },
      ChecksumResponseModel: {
        properties: {
          checksum: {
            type: "string",
            title: "Checksum"
          },
          sku: {
            type: "integer",
            title: "Sku"
          }
        },
        type: "object",
        required: ["checksum", "sku"],
        title: "ChecksumResponseModel"
      },
      GroupTagModel: {
        properties: {
          updated: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Updated"
          },
          created: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Created"
          },
          uid: {
            type: "string",
            title: "Uid"
          },
          name: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Name"
          }
        },
        type: "object",
        required: ["uid", "name"],
        title: "GroupTagModel"
      },
      HTTPValidationError: {
        properties: {
          detail: {
            items: {
              $ref: "#/components/schemas/ValidationError"
            },
            type: "array",
            title: "Detail"
          }
        },
        type: "object",
        title: "HTTPValidationError"
      },
      ManufacturerBaseModel: {
        properties: {
          updated: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Updated"
          },
          created: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Created"
          },
          mid: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Mid"
          },
          mname: {
            type: "string",
            title: "Mname"
          },
          name_alternatives: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Name Alternatives"
          },
          assets: {
            anyOf: [{
              additionalProperties: {
                $ref: "#/components/schemas/PimAssetModel"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Assets"
          }
        },
        type: "object",
        required: ["mname"],
        title: "ManufacturerBaseModel"
      },
      ManufacturerModel: {
        properties: {
          updated: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Updated"
          },
          created: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Created"
          },
          mid: {
            type: "integer",
            title: "Mid"
          },
          mname: {
            type: "string",
            title: "Mname"
          },
          name_alternatives: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Name Alternatives"
          },
          assets: {
            anyOf: [{
              additionalProperties: {
                $ref: "#/components/schemas/PimAssetModel"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Assets"
          }
        },
        type: "object",
        required: ["mid", "mname"],
        title: "ManufacturerModel"
      },
      PaginationViewResponseModel: {
        properties: {
          data: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Data",
            "default": {}
          },
          skip: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Skip",
            nullable: true
          },
          limit: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Limit",
            nullable: true
          },
          max_results: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Max Results"
          },
          sort: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Sort"
          },
          view: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "View"
          },
          ids: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Ids",
            "default": []
          }
        },
        type: "object",
        title: "PaginationViewResponseModel"
      },
      PimAssetModel: {
        properties: {
          uid: {
            type: "string",
            title: "Uid"
          },
          asset_type: {
            type: "string",
            title: "Asset Type"
          },
          url: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Url",
            nullable: true
          },
          url_type: {
            type: "string",
            title: "Url Type"
          },
          caption: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Caption",
            nullable: true
          },
          supplier_product_has_asset_id: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Supplier Product Has Asset Id",
            nullable: true
          },
          active: {
            type: "boolean",
            title: "Active"
          }
        },
        type: "object",
        required: ["uid", "asset_type", "url_type", "active"],
        title: "PimAssetModel"
      },
      ProductModel: {
        properties: {
          updated: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Updated"
          },
          created: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Created"
          },
          sku: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Sku"
          },
          checksum: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Checksum"
          },
          gtin: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Gtin"
          },
          mid: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Mid"
          },
          msku: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Msku"
          },
          mname: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Mname"
          },
          msrp: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Msrp"
          },
          assets: {
            anyOf: [{
              additionalProperties: {
                $ref: "#/components/schemas/PimAssetModel"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Assets"
          },
          asset_index: {
            anyOf: [{
              additionalProperties: {
                items: {},
                type: "array"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Asset Index"
          },
          group_tags: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Group Tags"
          },
          release_date: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Release Date",
            nullable: true
          },
          presale_date: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Presale Date",
            nullable: true
          },
          availability_date: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Availability Date",
            nullable: true
          },
          release_date_reached: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Release Date Reached"
          },
          presale_date_reached: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Presale Date Reached"
          },
          availability_date_reached: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Availability Date Reached"
          },
          requested_data_compatibility: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Requested Data Compatibility",
            "default": []
          },
          data_compatibility: {
            anyOf: [{
              items: {
                type: "string"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Data Compatibility",
            "default": []
          },
          weight: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Weight"
          },
          height: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Height"
          },
          length: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Length"
          },
          width: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Width"
          },
          logistic_weight: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Logistic Weight"
          },
          volume_weight: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Volume Weight"
          },
          name_text: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Name Text"
          },
          short_text: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Short Text"
          },
          long_text: {
            anyOf: [{
              additionalProperties: {
                type: "string"
              },
              type: "object"
            }, {
              type: "null"
            }],
            title: "Long Text"
          },
          kn8_code: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Kn8 Code"
          },
          country_of_origin: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Country Of Origin"
          },
          supplementary_unit: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Supplementary Unit",
            nullable: true
          },
          supplementary_unit_value: {
            anyOf: [{
              type: "number"
            }, {
              type: "null"
            }],
            title: "Supplementary Unit Value",
            nullable: true
          },
          google_category: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Google Category"
          },
          letzshop_category: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Letzshop Category"
          },
          rakuten_fr_category: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Rakuten Fr Category"
          },
          asin: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Asin"
          },
          amazon_fees: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Amazon Fees"
          },
          unit: {
            anyOf: [{
              type: "string",
              "enum": ["METERS", "PIECES"]
            }, {
              type: "null"
            }],
            title: "Unit",
            "default": "PIECES"
          },
          tax_type: {
            anyOf: [{
              type: "string",
              "enum": ["BOOK", "SOFTWARE", "STANDARD_RATE"]
            }, {
              type: "null"
            }],
            title: "Tax Type",
            "default": "STANDARD_RATE"
          },
          successor_sku: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Successor Sku"
          },
          product_type: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Product Type"
          },
          children: {
            anyOf: [{
              type: "object"
            }, {
              type: "null"
            }],
            title: "Children"
          },
          cross_selling_type: {
            anyOf: [{
              type: "string",
              "enum": ["CONSUMABLES", "ACCESSORIES"]
            }, {
              type: "null"
            }],
            title: "Cross Selling Type"
          },
          cross_selling_skus: {
            anyOf: [{
              items: {
                type: "integer"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Cross Selling Skus"
          },
          purchase_units: {
            anyOf: [{
              items: {
                type: "integer"
              },
              type: "array"
            }, {
              type: "null"
            }],
            title: "Purchase Units",
            "default": [1]
          },
          missing_intrastat: {
            anyOf: [{
              type: "boolean"
            }, {
              type: "null"
            }],
            title: "Missing Intrastat",
            "default": true
          },
          import_class: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Import Class"
          },
          import_date: {
            anyOf: [{
              type: "string",
              format: "date-time"
            }, {
              type: "null"
            }],
            title: "Import Date"
          }
        },
        type: "object",
        title: "ProductModel"
      },
      RenderChannelDataModel: {
        properties: {
          org_id: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Org Id"
          },
          type: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Type",
            "default": "product"
          },
          channel: {
            type: "string",
            title: "Channel"
          },
          sku: {
            anyOf: [{
              type: "integer"
            }, {
              type: "null"
            }],
            title: "Sku"
          },
          checksum: {
            type: "string",
            title: "Checksum"
          },
          data: {
            type: "object",
            title: "Data"
          }
        },
        type: "object",
        required: ["channel", "checksum", "data"],
        title: "RenderChannelDataModel"
      },
      ValidationError: {
        properties: {
          loc: {
            items: {
              anyOf: [{
                type: "string"
              }, {
                type: "integer"
              }]
            },
            type: "array",
            title: "Location"
          },
          msg: {
            type: "string",
            title: "Message"
          },
          type: {
            type: "string",
            title: "Error Type"
          }
        },
        type: "object",
        required: ["loc", "msg", "type"],
        title: "ValidationError"
      },
      ValidationFieldResultModel: {
        properties: {
          valid: {
            type: "boolean",
            title: "Valid"
          },
          error: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Error"
          },
          compatibilities: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Compatibilities",
            "default": []
          }
        },
        type: "object",
        required: ["valid"],
        title: "ValidationFieldResultModel"
      },
      ValidationInfoMetaDataModel: {
        properties: {
          fields: {
            additionalProperties: {
              $ref: "#/components/schemas/ValidationFieldResultModel"
            },
            type: "object",
            title: "Fields",
            "default": {}
          }
        },
        type: "object",
        title: "ValidationInfoMetaDataModel"
      },
      ValidationInfoModel: {
        properties: {
          val_class: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Val Class"
          },
          val_uid: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Val Uid"
          },
          checksum: {
            anyOf: [{
              type: "string"
            }, {
              type: "null"
            }],
            title: "Checksum"
          },
          data_compatibility: {
            items: {
              type: "string"
            },
            type: "array",
            title: "Data Compatibility"
          },
          meta_data: {
            anyOf: [{
              $ref: "#/components/schemas/ValidationInfoMetaDataModel"
            }, {
              type: "null"
            }]
          }
        },
        type: "object",
        title: "ValidationInfoModel"
      }
    }
  }
};
var pim_api = exports.pim_api = (0, _lsfastapiClient.Api)(openapi);
//# sourceMappingURL=index.js.map